// © 2015-2021 WDNA - All Rights Reserved
import * as React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';

const DATE_FORMAT: string = 'D MMMM.YYYY';

interface Props extends RouteComponentProps {
  mainFilter: {
    id?: string;
    company?: string;
    sensorArray?: ({
      id: number;
      description: string;
    } & Record<string, any>)[];
    companyArray?: ({
      id: number;
      name: string;
    } & Record<string, any>)[];
    arrFilterDate?: any[];
  };
}

class LocationDateIndicators extends React.Component<Props> {
  public static defaultProps: Partial<Props> = {
    mainFilter: {},
  };

  public getDateAsString = (): string => {
    const { arrFilterDate } = this.props.mainFilter || {};
    if (!arrFilterDate || !arrFilterDate[0]) return '';

    const { date1, date2 } = arrFilterDate[0];

    const date1AsString: string = moment(date1, 'YYYY-MM-DD').add(1, 'days').utc().format(DATE_FORMAT);
    const date2AsString: string = moment(date2, 'YYYY-MM-DD').add(1, 'days').utc().format(DATE_FORMAT);
    return `${date1AsString} - ${date2AsString}`;
  }

  public getLocationAsString = (): string => {
    const { id, company, companyArray, sensorArray } = this.props.mainFilter;
    if (id !== undefined && sensorArray !== undefined) {
      for (let i: number = 0; i < sensorArray.length; i++) {
        if (sensorArray[i].id === parseInt(id, 10)) {
          return sensorArray[i].description;
        }
      }
    }
    if (companyArray !== undefined) {
      for (let i: number = 0; i < companyArray.length; i++) {
        const companyId: number = companyArray[i].id;
        if (company === companyId.toString()) {
          return companyArray[i].name;
        }
      }
    }

    return 'All Locations';
  }

  public render(): JSX.Element {
    const date: string = this.getDateAsString();
    const location: string = this.getLocationAsString();

    return (
      <div className="location-date-indicator">
        <h1><i className="fa fa-map-marker" /> {location}</h1>
        <h1><i className="fa fa-calendar" />  {date}</h1>
      </div>
    );
  }
}

const mapStateToProps = (state: any, ownProps: Props): Props => {
  return {
    ...ownProps,
    mainFilter: state.mainFilter,
  };
};

export default connect(mapStateToProps)(LocationDateIndicators);
